<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__update-item"
  >
    <template #pic>
      <div class="label-pic is-pink-epic">
        <icon
          data="@icon/epic.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="notification.epicUrl"
        >
          Epic {{ notification.epicSequenceNumber }}
        </a>
        {{ updatedField }} has been updated by
        <span class="notification__update-item__initiator"
          >@{{ notification.initiatorFullName }}</span
        >
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__content notification__update-item__description"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.epicDescription"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :url="notification.epicUrl"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import { computed } from "vue"

import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { ReferencedText } from "@/components/Reference"

import { NotificationEpic } from "@/models/Notification/NotificationEpic"

const props = defineProps({
  notification: {
    type: NotificationEpic,
    required: true
  }
})

const updatedField = computed(() => {
  if (props.notification.nameChanged && props.notification.descriptionChanged) {
    return "Name and Description"
  }
  if (props.notification.nameChanged) {
    return "Name"
  }
  return "Description"
})
</script>
